import { render } from "./ShareButton.vue?vue&type=template&id=492fc286&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"

import "@/Common/Styles/Share/socialMediaShareButton.scss?vue&type=style&index=0&id=492fc286&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492fc286"]])

export default __exports__